var _g, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGreenOpenLock = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_161_1",
    "data-name": "Component 161 \\u2013 1",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_159_3",
    "data-name": "Component 159 \\u2013 3"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1661",
    "data-name": "Rectangle 1661",
    width: 25,
    height: 25,
    rx: 12,
    transform: "translate(25) rotate(90)",
    fill: "#5ddb65"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ic_lock_open_24px",
    d: "M9.84,12.68a1.46,1.46,0,1,0-1.46-1.46A1.464,1.464,0,0,0,9.84,12.68Zm4.38-6.57h-.73V4.65a3.65,3.65,0,0,0-7.3,0H7.577a2.263,2.263,0,0,1,4.526,0V6.11H5.46A1.464,1.464,0,0,0,4,7.57v7.3a1.464,1.464,0,0,0,1.46,1.46h8.76a1.464,1.464,0,0,0,1.46-1.46V7.57A1.464,1.464,0,0,0,14.22,6.11Zm0,8.76H5.46V7.57h8.76Z",
    transform: "translate(2.66 2.834)",
    fill: "#373737"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGreenOpenLock, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Green_Open_Lock.cbdb3930.svg";
export { ForwardRef as ReactComponent };